/*
 * apiPath: is the endpoint to fetch data from the CMS
 * urlPrefix: is the prefix to add to the slug of the page when creating static content.
 * So if if we would have "hub/collection-type" called "company" and the urlPrefix "company" the url would be "/company/about"
 * urlPathStartsWith: is used when we have hub "blog" but by default blog slug doesn't contain "blog" in slug
 */
export const paths = [
  {
    apiPath: '/pages',
    contentType: 'page',
    urlPrefix: '',
    urlPathStartsWith: null,
  },
  {
    apiPath: '/blog-topics',
    contentType: 'blog-topic',
    urlPrefix: '',
    urlPathStartsWith: 'blog/topics',
  },
  {
    apiPath: '/blogs',
    contentType: 'blog',
    urlPrefix: '',
    urlPathStartsWith: 'blog',
  },
  {
    apiPath: '/footers',
    contentType: 'footer',
    urlPrefix: '',
    urlPathStartsWith: null,
  },
  {
    apiPath: '/headers',
    contentType: 'header',
    urlPrefix: '',
    urlPathStartsWith: null,
  },
] as const;

export type APIPath = (typeof paths)[number]['apiPath'];
export type ContentType = (typeof paths)[number]['contentType'];
